module.exports = __webpack_public_path__ + "img/sertifika-2.2878e00f.jpg";